/**
 * String case conversion utilities for reporting components
 */

/**
 * Convert snake_case string to camelCase
 *
 * @example
 * snakeToCamelCase('employee_name') // 'employeeName'
 * snakeToCamelCase('tas_program_template_field_name') // 'tasProgramTemplateFieldName'
 */
export function snakeToCamelCase(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

/**
 * Convert camelCase string to snake_case
 *
 * @example
 * camelToSnakeCase('employeeName') // 'employee_name'
 * camelToSnakeCase('tasProgramTemplateFieldName') // 'tas_program_template_field_name'
 */
export function camelToSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
